module.exports = __webpack_public_path__ + "img/hr-heat-pipe-corner-up-right-4.77406d06.png";